import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICertificaCellulareState } from './certifica-cellulare';

const feature = createFeatureSelector<ICertificaCellulareState>('certificaCellulare');

export const selectEsitoCertCellulare = createSelector(
  feature,
  (state) => state.esito ?? ''
);

export const selectLoadingCertCellulare = createSelector(
  feature,
  (state) => state.loading
);

export const selectSeedCertCellulare = createSelector(
  feature,
  (state) => state.seed
);

export const selectCellulareCertCellulare = createSelector(
  feature,
  (state) => state.cellulare
);

export const selectOtpTtlSecondsCellulare = createSelector(
  feature,
  (state) => state.otpTtlSeconds
);

export const selectUsernameCertCellulare = createSelector(
  feature,
  (state) => state.username
);

export const selectMsgCodeCertCellulare = createSelector(
  feature,
  (state) => state.msgCode
);

export const selectMaxTentativiCertCellulare = createSelector(
  feature,
  (state) => state.maxTentativi
);
